<template>
  <table class="table">
    <tr>
      <th>{{ $t("router.ip_vpn")}}</th>
      <td class="fw-bold">{{ data.ip_vpn }}</td>
    </tr>
    <tr>
      <th>{{ $t("unit.subnet_mask")}}</th>
      <td class="fw-bold">{{ data.subnet_mask }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  props:{
    data: {
      type: Array | Object
    }
  }
}
</script>
